<template>
  <VerifyIdentityError
    class="md:w-480 md:mx-auto"
    :errorTitle="$t('common.no_contact_info_found')"
    :errorBody="coalescedSupportText('common.contact_health_plan_csr.help')"
    :cancelText="$t('common.return_to_login')"
    @cancel="handleReturn"
  />
</template>

<script>
import { VerifyIdentityError } from '../../common/mfa'
import { mapActions } from 'vuex'
import supportMixin from '../../mixins/support'

export default {
  components: { VerifyIdentityError },
  mixins: [supportMixin],
  methods: {
    ...mapActions(['logout']),
    handleReturn() {
      this.logout()
    },
  },
}
</script>
